import { render } from "./eye_profile.vue?vue&type=template&id=87daf3aa&scoped=true"
import script from "./eye_profile.vue?vue&type=script&lang=js"
export * from "./eye_profile.vue?vue&type=script&lang=js"

import "./eye_profile.vue?vue&type=style&index=0&id=87daf3aa&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87daf3aa"]])

export default __exports__